import CreateChannel from './CreateChannel'
import ViewChannel from './ViewChannel'

export default { CreateChannel, ViewChannel }
